const CheckModel = {
    ALL: 'all',
    PARENT: 'parent',
    LEAF: 'leaf',
};

export default { CheckModel };
